import { FAILURE, REQUEST, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

const GET_ALL_CONFIG_LIST = createRequestTypes('GET_ALL_CONFIG_LIST');
const getAllConfigList = {
  request: () => action(GET_ALL_CONFIG_LIST[REQUEST]),
  success: data => action(GET_ALL_CONFIG_LIST[SUCCESS], { data }),
  failure: error => action(GET_ALL_CONFIG_LIST[FAILURE], { error }),
};

export { GET_ALL_CONFIG_LIST, getAllConfigList };
